import styled from 'styled-components';

export const Container = styled.div``;

export const SearchContainer = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  width: 100%;
  border-radius: 6px;
  background-color: #f5f5f5;
  padding: 10px;
`;
